import { Droppable } from "@hello-pangea/dnd";
import { MoreHorizontal } from "lucide-react";

import { OrderCard } from "@/features/custom-orders/components/OrderCard";
import type { Order } from "@/shared/types";

interface Props {
  id: string;
  title: string;
  orders: Order[];
  color: string;
  onCardClick: (order: Order) => void;
  readOnly?: boolean;
}

export const KanbanColumn = ({
  id,
  title,
  orders,
  color,
  onCardClick,
  readOnly = false,
}: Props) => {
  return (
    <div className="flex flex-col min-h-0 h-full w-[75vw] sm:w-[280px] md:w-[320px] shrink-0 bg-gray-50/50 rounded-2xl border border-gray-200/60 shadow-sm">
      <div
        className={`p-4 border-b border-gray-100 flex justify-between items-center rounded-t-2xl shrink-0 ${color}`}
      >
        <div className="flex items-center gap-2 min-w-0">
          <h3 className="font-bold text-[#2D2D2D] truncate">{title}</h3>
          <span className="bg-white/50 text-[#2D2D2D] px-2 py-0.5 rounded-full text-xs font-bold shadow-sm shrink-0">
            {orders.length}
          </span>
        </div>

        <button className="text-gray-400 hover:text-[#593D31] shrink-0">
          <MoreHorizontal size={18} />
        </button>
      </div>

      <Droppable droppableId={id}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`p-3 flex-1 min-h-0 overflow-y-auto overscroll-contain transition-colors ${
              snapshot.isDraggingOver ? "bg-gray-100/80" : ""
            }`}
            style={{ WebkitOverflowScrolling: "touch" }}
          >
            {orders.map((order, index) => (
              <OrderCard
                key={order.id}
                order={order}
                index={index}
                onClick={onCardClick}
                readOnly={readOnly}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
};
